module.exports = __webpack_public_path__ + "static/media/girl3.95a818de.svg";